<template>
  <div>
    <div class="header" :style="{ '--header-opacity': headerOpacity }">
      <div class="header-logo">
        <img
          src="../../assets/sigma-logo.jpg"
          alt="logo"
          class="header-logo-content"
          @click="handleClickLogo"
          ondragstart="return false;"
        />
      </div>
      <button
        class="mobile-product-button"
        type="button"
        @click="toggleMobileProductPanel"
      >
        {{ productMenuLabel }}
      </button>
      <button
        class="header-menu-toggle"
        type="button"
        :aria-expanded="mobileMenuOpen ? 'true' : 'false'"
        aria-label="Toggle navigation menu"
        @click="toggleMobileMenu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
      <div
        class="mobile-menu-backdrop"
        v-if="mobileMenuOpen"
        @click="closeMobileMenu"
      ></div>
      <div class="header-content" :class="{ 'is-open': mobileMenuOpen }">
        <ul class="nav">
          <li
            class="nav-link"
            :class="{ 'mobile-hidden': item.href === '#products' }"
            v-for="item in content.menus"
            :key="item.label"
            @click="handleJump(item.href)"
          >
          <!-- <el-popover
            placement="bottom-start"
            trigger="click"
            :offset="-200"
            :visible-arrow="true"
            v-if="item.href === '#products'"
          > -->
          <el-cascader
            class="my-cascader"
            v-if="item.href === '#products'"
            :options="i18n.productNameOptions"
            :placeholder="i18n.productSelectTip"
            @change="handleSelectProduct"
          >
          </el-cascader>
          <span v-if="item.href === '#products'">{{ item.label }}</span>
          <!-- <span slot="reference">{{ item.label }}</span> -->
          <!-- </el-popover> -->
          <span v-else>{{ item.label }}</span>
          </li>

          <li class="nav-link desktop-lang" v-if="isCnLocale()" @click="handleToEn">EN</li>
          <li class="nav-link desktop-lang" v-else @click="handleToCn">中文</li>
        </ul>
      </div>
    </div>

    <transition name="mobile-product-pop">
      <div class="mobile-product-panel" v-if="mobileProductOpen" @click.self="closeMobileProductPanel">
        <div class="mobile-product-sheet">
          <div class="mobile-product-title">
            <button
              class="mobile-product-back"
              type="button"
              v-if="mobileProductPath.length"
              @click="handleMobileProductBack"
            >
              ‹
            </button>
            <span>{{ mobileProductTitle }}</span>
            <button
              class="mobile-product-close"
              type="button"
              @click="closeMobileProductPanel"
            >
              ×
            </button>
          </div>
          <div class="mobile-product-list">
            <button
              class="mobile-product-item"
              type="button"
              v-for="option in mobileProductOptions"
              :key="option.value"
              @click="handleMobileProductOption(option)"
            >
              <span>{{ option.label }}</span>
              <span class="mobile-product-meta" v-if="option.children">›</span>
              <span class="mobile-product-meta" v-else-if="option.value !== option.label">
                {{ option.value }}
              </span>
            </button>
          </div>
        </div>
      </div>
    </transition>

    <button
      class="mobile-lang-float"
      type="button"
      :style="langButtonStyle"
      @click="handleFloatingLangClick"
      @pointerdown="handleLangPointerDown"
    >
      {{ isCnLocale() ? "EN" : "中" }}
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      headerOpacity: 0.6,
      mobileMenuOpen: false,
      mobileProductOpen: false,
      mobileProductPath: [],
      langButtonPosition: null,
      langDragOffset: { x: 0, y: 0 },
      langButtonMoved: false,
    };
  },

  computed: {
    content() {
      return this.i18n.header;
    },
    locale() {
      return `${this.isCnLocale() ? "" : "/en"}`;
    },
    isInProductRoute() {
      const currentPath = this.$route.path;
      const isProducts = currentPath.indexOf("/products") !== -1;
      return isProducts;
    },
    langButtonStyle() {
      if (!this.langButtonPosition) return {};
      return {
        left: `${this.langButtonPosition.x}px`,
        top: `${this.langButtonPosition.y}px`,
        right: "auto",
        bottom: "auto",
      };
    },
    productMenuLabel() {
      const productMenu = this.content.menus.find((item) => item.href === "#products");
      return productMenu ? productMenu.label : this.i18n.productSelectTip;
    },
    mobileProductOptions() {
      const current = this.mobileProductPath[this.mobileProductPath.length - 1];
      return current && current.children ? current.children : this.i18n.productNameOptions;
    },
    mobileProductTitle() {
      const current = this.mobileProductPath[this.mobileProductPath.length - 1];
      return current ? current.label : this.productMenuLabel;
    },
  },

  watch: {
    isInProductRoute(v) {
      if (v) {
        this.headerOpacity = 1;
      }
    },
  },

  created() {
    this.$nextTick(() => {
      window.addEventListener("scroll", this.handleWindowScroll);
    });
  },

  destroyed() {
    window.removeEventListener("scroll", this.handleWindowScroll);
    this.removeLangDragListeners();
  },

  methods: {
    handleToEn() {
      this.closeMobileMenu();
      this.handleLocaleChange("en");
    },
    handleToCn() {
      this.closeMobileMenu();
      this.handleLocaleChange("cn");
    },
    toggleMobileMenu() {
      this.mobileProductOpen = false;
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false;
    },
    toggleMobileProductPanel() {
      this.mobileMenuOpen = false;
      this.mobileProductOpen = !this.mobileProductOpen;
    },
    closeMobileProductPanel() {
      this.mobileProductOpen = false;
      this.mobileProductPath = [];
    },
    handleMobileProductBack() {
      this.mobileProductPath = this.mobileProductPath.slice(0, -1);
    },
    handleMobileProductOption(option) {
      if (option.children && option.children.length) {
        this.mobileProductPath = [...this.mobileProductPath, option];
        return;
      }
      const productPath = [...this.mobileProductPath, option].map((item) => item.value);
      this.handleSelectProduct(productPath);
    },
    handleFloatingLangClick() {
      if (this.langButtonMoved) {
        this.langButtonMoved = false;
        return;
      }
      if (this.isCnLocale()) {
        this.handleToEn();
      } else {
        this.handleToCn();
      }
    },
    handleLangPointerDown(event) {
      const rect = event.currentTarget.getBoundingClientRect();
      this.langDragOffset = {
        x: event.clientX - rect.left,
        y: event.clientY - rect.top,
      };
      this.langButtonMoved = false;
      window.addEventListener("pointermove", this.handleLangPointerMove);
      window.addEventListener("pointerup", this.handleLangPointerUp);
    },
    handleLangPointerMove(event) {
      const size = 40;
      const x = Math.max(
        8,
        Math.min(window.innerWidth - size - 8, event.clientX - this.langDragOffset.x)
      );
      const y = Math.max(
        64,
        Math.min(window.innerHeight - size - 8, event.clientY - this.langDragOffset.y)
      );
      this.langButtonMoved = true;
      this.langButtonPosition = { x, y };
    },
    handleLangPointerUp() {
      this.removeLangDragListeners();
    },
    removeLangDragListeners() {
      window.removeEventListener("pointermove", this.handleLangPointerMove);
      window.removeEventListener("pointerup", this.handleLangPointerUp);
    },
    handleLocaleChange(locale) {
      const pid = this.$route.query.pid;
      const isEnglish = locale === "en";
      this.$router.push({
        path: this.isInProductRoute
          ? `/products${isEnglish ? "/en" : ""}`
          : `/home${isEnglish ? "/en" : ""}`,
        query: pid ? { pid } : {},
      });
    },
    handleWindowScroll() {
      if (this.isInProductRoute) {
        return;
      }
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      const windowHeight = document.documentElement.clientHeight;

      const opacity = scrollTop / windowHeight;
      this.headerOpacity = Math.max(0.6, opacity);
    },
    handleJump(id) {
      this.closeMobileMenu();
      this.closeMobileProductPanel();
      const currentPath = this.$route.path;

      const isProducts = currentPath.indexOf("/products") !== -1;
      if (id === "#products") {
        if (!isProducts) {
          const products = this.$store.state.currentProduct;
          console.log(products, ">>>>");
          if (products) {
            this.$router.push({
              path: `/products${this.locale}`,
              query: {
                pid: products[products.length - 1],
              },
            });
            this.headerOpacity = 1;
          }
        }
        return;
      }
      const isHome = currentPath.indexOf("/home") !== -1;
      if (!isHome) {
        this.$router.push(`/home${this.locale}`);
      }
      setTimeout(
        () => {
          this.scrollToAnchor(id);
        },
        isHome ? 0 : 500
      );
    },

    scrollToAnchor(id) {
      const anchorEle = document.querySelector(id);
      if (!anchorEle) return;
      const headerOffset = window.innerWidth <= 800 ? 68 : 82;
      const anchorTop = anchorEle.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: Math.max(0, anchorTop - headerOffset),
        behavior: "smooth",
      });
    },

    handleClickLogo() {
      this.closeMobileMenu();
      this.closeMobileProductPanel();
      this.$router.push(`/home${this.locale}`);
    },

    handleSelectProduct(product) {
      this.closeMobileMenu();
      this.closeMobileProductPanel();
      this.$store.dispatch("CHANGE_PRODUCT", product);
      this.headerOpacity = 1;
      console.log("asdfasdfasfd", product, this.locale);
      this.$router.push({
        path: `/products${this.locale}`,
        query: {
          pid: product[product.length - 1],
        },
      });
    },
  },
};
</script>

<style lang='scss' scoped>
ul,
li {
  text-decoration: none;
  list-style: none;
  margin: 0;
  padding: 0;
}

.header {
  position: fixed;
  z-index: 200;
  top: 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  height: 70px;
  box-sizing: border-box;
  background-color: rgba(34, 45, 56, var(--header-opacity));
  padding: 0 120px;
  user-select: none;

  &-logo {
    width: 30%;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 100px;

    &-content {
      // background: linear-gradient(to right,rgba(0, 0, 0, 0.1),rgba(0, 0, 0, 0.6),rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.1));
      border-radius: 4px;
      padding: 10px;
      // height: 36px;
      // background: #fff;
      width: 120px;
      cursor: pointer;
      // box-shadow: 0 0 6px 0px rgba($color: #fff, $alpha: 0.8);

      &:hover {
        // box-shadow: 0 0 6px 0px rgba($color: #fff, $alpha: 1);
        background: rgba($color: #000000, $alpha: 0.2);
      }
    }
  }

  &-content {
    width: 70%;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .nav {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      flex: 1;
      max-width: 600px;

      &-link {
        position: relative;
        display: flex;
        height: 70px;
        font-size: 17px;
        font-weight: 400;
        color: #fff;
        cursor: pointer;
        flex-shrink: 0;
        align-items: center;
        margin-right: 20px;
        &:hover {
          color: #33a1d0;
        }

        .my-cascader {
          position: absolute;
          opacity: 0;
        }
      }
    }
  }

  &-menu-toggle {
    display: none;
  }
}

.mobile-lang-float {
  display: none;
}

.mobile-product-button,
.mobile-product-panel,
.mobile-menu-backdrop {
  display: none;
}

@media screen and (max-width: 800px) {
  .header {
    height: 56px;
    padding: 0 12px;
    align-items: center;

    &-logo {
      width: auto;
      flex-shrink: 0;
      margin-right: 12px;

      &-content {
        width: 100px;
        padding: 6px;
      }
    }

    &-content {
      position: absolute;
      z-index: 201;
      top: 56px;
      left: 0;
      display: none;
      width: 100%;
      padding: 8px 16px 14px;
      box-sizing: border-box;
      background: rgba(34, 45, 56, 0.97);
      background: #222d38;
      box-shadow: 0 12px 24px rgba(0, 0, 0, 0.24);

      &.is-open {
        display: block;
      }

      .nav {
        display: block;
        max-width: none;

        &-link {
          display: block;
          height: auto;
          padding: 13px 4px;
          margin-right: 0;
          border-bottom: 1px solid rgba(255, 255, 255, 0.16);
          font-size: 16px;
          text-align: left;

          &:last-child {
            border-bottom: 0;
          }
        }

        .mobile-hidden {
          display: none;
        }
      }
    }

    &-menu-toggle {
      display: inline-flex;
      width: 40px;
      height: 40px;
      margin-left: 8px;
      align-self: center;
      padding: 0;
      border: 0;
      border-radius: 4px;
      background: transparent;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 5px;
      cursor: pointer;

      span {
        width: 22px;
        height: 2px;
        border-radius: 2px;
        background: #fff;
      }
    }
  }

  .mobile-product-button {
    display: inline-flex;
    height: 32px;
    margin-left: auto;
    padding: 0 12px;
    border: 1px solid rgba(255, 255, 255, 0.34);
    border-radius: 18px;
    color: #fff;
    background: rgba(255, 255, 255, 0.08);
    align-items: center;
    align-self: center;
    font-size: 14px;
    line-height: 1;
  }

  .mobile-menu-backdrop {
    position: fixed;
    z-index: 199;
    top: 56px;
    right: 0;
    bottom: 0;
    left: 0;
    display: block;
    background: transparent;
  }

  .mobile-product-panel {
    position: fixed;
    z-index: 240;
    top: 0;
    left: 0;
    bottom: 0;
    display: block;
    width: 100%;
    padding: 0 18px;
    box-sizing: border-box;
    background: rgba(0, 0, 0, 0.2);
  }

  .mobile-product-sheet {
    position: absolute;
    top: 76px;
    left: 50%;
    overflow: hidden;
    width: min(360px, calc(100vw - 36px));
    max-height: calc(100vh - 112px);
    border-radius: 14px;
    background: #fff;
    box-shadow: 0 16px 40px rgba(0, 0, 0, 0.28);
    transform: translateX(-50%);
  }

  .mobile-product-title {
    position: relative;
    display: flex;
    height: 50px;
    padding: 0 46px;
    border-bottom: 1px solid #edf0f2;
    box-sizing: border-box;
    justify-content: center;
    align-items: center;
    color: #222d38;
    font-size: 16px;
    font-weight: 700;

    button {
      position: absolute;
      top: 10px;
      width: 30px;
      height: 30px;
      padding: 0;
      border: 0;
      color: #66717c;
      background: transparent;
      font-size: 24px;
      line-height: 1;
    }
  }

  .mobile-product-back {
    left: 12px;
  }

  .mobile-product-close {
    right: 12px;
  }

  .mobile-product-list {
    overflow-y: auto;
    max-height: calc(100vh - 162px);
    padding: 6px 0 10px;
    -webkit-overflow-scrolling: touch;
  }

  .mobile-product-item {
    display: flex;
    width: 100%;
    min-height: 48px;
    padding: 0 18px;
    border: 0;
    border-bottom: 1px solid #f0f2f4;
    box-sizing: border-box;
    color: #222d38;
    background: #fff;
    justify-content: space-between;
    align-items: center;
    font-size: 15px;
    text-align: left;
  }

  .mobile-product-meta {
    margin-left: 12px;
    color: #8a949e;
    font-size: 13px;
    flex-shrink: 0;
  }

  .mobile-product-pop-enter-active,
  .mobile-product-pop-leave-active {
    transition: opacity 0.18s ease;

    .mobile-product-sheet {
      transition: transform 0.18s ease, opacity 0.18s ease;
    }
  }

  .mobile-product-pop-enter,
  .mobile-product-pop-leave-to {
    opacity: 0;

    .mobile-product-sheet {
      opacity: 0;
      transform: translate(-50%, -10px);
    }
  }

  .mobile-lang-float {
    position: fixed;
    right: 14px;
    bottom: 84px;
    z-index: 260;
    display: block;
    width: 38px;
    height: 38px;
    padding: 0;
    border: 1px solid rgba(255, 255, 255, 0.28);
    border-radius: 50%;
    color: #fff;
    background: rgba(34, 45, 56, 0.72);
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.18);
    font-size: 13px;
    font-weight: 700;
    line-height: 38px;
    text-align: center;
    touch-action: none;
    cursor: grab;
  }
}
</style>
